/* eslint-disable no-console */
<template>
<div  class="mb-r">
    <mdb-row  class="mb-r">
        <mdb-col md="12">
          <mdb-col col="12"
            class="bg-dark white-text p-3"
          >
            <mdb-row>
              <mdb-col md="3">
                <h4 class="mt-2"><b>Weekly Report</b></h4>
              </mdb-col>
              <mdb-col md="6"></mdb-col>
              <mdb-col md="3">
                <button class="btn btn-outline-white btn-block btn-sm mt-1"  @click.prevent="downLoadCSV()">
                  Download CSV
                </button>
              </mdb-col>
            </mdb-row>
          </mdb-col>
          
          <mdb-col col="12" class="px-3 py-2">
            <table class="table table-bordered">
              <tr class="header">
                <th>COACH</th>
                <th>CENTRO</th>
                <th>FECHA</th>
                <th>HORARIO</th>
                <th>TOTAL</th>
                <th>ASISTENCIA</th>
                <th>PORCENTAJE</th>
                <th>SEMANA</th>
                <th>BAJAS</th>
              </tr>
              <tr v-for="item in statData" :key="item.group">
                <td>{{item.teacher}}</td>
                <td>{{item.group}}</td>
                <td>{{item.date}}</td>
                <td>{{item.schedule}}</td>
                <td>{{item.total}}</td>
                <td>{{item.attended}}</td>
                <td>{{item.percent}}</td>
                <td>{{item.week}}</td>
                <td>{{item.disabled}}</td>
              </tr>
            </table>
          </mdb-col>
        </mdb-col>
      </mdb-row>
</div>
</template>

<script>
import axios from "axios";
import { mdbRow, mdbCol} from "mdbvue";
import moment from 'moment'

export default {
    name: 'StudentStatusReport',
    components: {
        mdbRow,
        mdbCol,
    },
    data() {
        return {
            statData: [],
            token : localStorage.getItem("fastAdminToken") 
        }
    },
    methods: {
      loadStatusData() {
        this.$toast.open({
            message: "Processing : Loading Data...",
            type: 'info'
        })
        const config = {
            headers: {
                Authorization: "Bearer " + this.token,
                'Content-Type': 'application/json'
            }
        }
        axios.post(this.$apiURI + "/groups-list-status/get", {}, config)
        .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                  message: "Error : " + response.data.message,
                  type: "error",
              });
            } else {
              this.statData = [];
              console.log(response.data.data.stats);
              for (var item of response.data.data.stats) {
                let stats = {
                  teacher: item.teacher,
                  group: item.group,
                  total: item.total,
                  disabled: item.disabled,
                  schedule: item.schedule || 'NA',
                };

                var ldate = 'NA'
                var lweek = 'NA'
                var week = 0;

                if (item.dates) {
                  for (var i = 20; i >= 0; i--){
                    if (item.dates[i]) {
                      ldate = item.dates[i];
                      week = i + 1;
                      break;
                    }
                  }
                }
                

                var attended_students = 0;

                if (week > 0) {
                  lweek = week;
                  for (var s in item.status) {
                    if (item.status[s][week-1].status == 'T' || item.status[s][week-1].status == 'A') {
                      attended_students ++;
                    }
                  }
                }

                stats['date'] = ldate;
                stats['week'] = lweek;
                stats['attended'] = attended_students;
                stats['percent'] = `${Math.round((attended_students / item.total) * 100)} %`

                this.statData.push(stats);
              }
            }
        })
        // .catch((error) => {
        //     this.$toast.open({
        //     message: "Error : " + error.response.data.message,
        //     type: "error",
        //     });
        // });
      },
      downLoadCSV() {
        let csvData = '';
        csvData += 'COACH,CENTRO,FECHA,HORARIO,TOTAL,ASISTENCIA,PORCENTAJE,SEMANA,BAJAS\n';
        for (var k of this.statData) {
          csvData += `${k.teacher},${k.group},${k.date},${k.schedule},${k.total},${k.attended},${k.percent},${k.week},${k.disabled}`;
          
          csvData += '\n';
        }
        var blob = new Blob([csvData], { type: 'text/csv;charset=utf-8,%EF%BB%BF' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, `${moment().format('MMMM Do YYYY')} report.csv`);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", `${moment().format('MMMM Do YYYY')} report.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
      }
    },
    mounted() {
        this.loadStatusData();
    }
}
</script>
